var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerpointLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 119,
    viewBox: "0 0 244 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "powerpoint logo asset",
    clipPath: "url(#clip0_2557_26793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.593 0.673828H40.9992C37.0711 0.673828 33.8867 3.85573 33.8867 7.7808V111.291C33.8867 115.216 37.0711 118.398 40.9992 118.398H236.593C240.521 118.398 243.705 115.216 243.705 111.291V7.7808C243.705 3.85573 240.521 0.673828 236.593 0.673828Z",
    fill: "#FF8F6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.8,
    d: "M141.927 7.78125H45.5675C43.0449 7.78125 41 9.8246 41 12.3452C41 14.8658 43.0449 16.9092 45.5675 16.9092H141.927C144.449 16.9092 146.494 14.8658 146.494 12.3452C146.494 9.8246 144.449 7.78125 141.927 7.78125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.8,
    d: "M63.0989 19.041H42.9154C41.8576 19.041 41 19.8979 41 20.955C41 22.012 41.8576 22.8689 42.9154 22.8689H63.0989C64.1567 22.8689 65.0143 22.012 65.0143 20.955C65.0143 19.8979 64.1567 19.041 63.0989 19.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.8,
    d: "M236.593 12.2561C236.593 9.78469 234.588 7.78125 232.115 7.78125C229.642 7.78125 227.637 9.78469 227.637 12.2561V12.4343C227.637 14.9057 229.642 16.9092 232.115 16.9092C234.588 16.9092 236.593 14.9057 236.593 12.4343V12.2561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.8,
    d: "M41 101.58L63.88 74.8424H94.142L110.1 53.5652L131.785 67.517L157.622 43.422L174.225 64.5868L199.319 49.2035H222.57L225.891 38.5816L236.593 36.0176",
    stroke: "white",
    strokeWidth: 1.02203,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.8,
    d: "M235.467 111.885H42.1259C41.5041 111.885 41 112.388 41 113.01V113.01C41 113.631 41.5041 114.135 42.1259 114.135H235.467C236.089 114.135 236.593 113.631 236.593 113.01C236.593 112.388 236.089 111.885 235.467 111.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.1551 62.9232L34.2483 34.3398H33.9563C27.1359 34.3514 20.5975 37.0605 15.7702 41.8751C10.943 46.6895 8.21962 53.2178 8.19531 60.0329V60.3247L38.1551 62.9232Z",
    fill: "#ED6C47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.5459 34.3398H34.2539V60.3247L47.2784 65.5217L60.3049 60.3247V60.0329C60.2806 53.2181 57.5574 46.6902 52.7307 41.8758C47.9038 37.0613 41.366 34.352 34.5459 34.3398Z",
    fill: "#FF8F6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.2994 60.3262V60.612C60.274 67.4279 57.5499 73.9569 52.7222 78.7722C47.8945 83.5875 41.3557 86.2979 34.5343 86.311H33.9603C27.1393 86.2968 20.6012 83.5861 15.7736 78.771C10.9462 73.956 8.22172 67.4276 8.19531 60.612V60.3262H60.2994Z",
    fill: "#D35230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.1,
    d: "M35.5506 47.111V74.8368C35.547 75.3085 35.4043 75.7687 35.1403 76.1598C34.8762 76.5509 34.5027 76.8555 34.0663 77.0355C33.7808 77.1535 33.4751 77.2152 33.1662 77.2174H14.3446C13.9792 76.799 13.6315 76.3655 13.3023 75.9182C9.98491 71.5044 8.19259 66.133 8.19534 60.6131V60.0415C8.18846 55.0621 9.64725 50.1908 12.3902 46.0336C12.6749 45.5873 12.9793 45.1538 13.3023 44.7344H33.1662C33.7962 44.7386 34.3994 44.9901 34.8455 45.4347C35.2916 45.8794 35.5448 46.4814 35.5506 47.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.2,
    d: "M34.2484 48.4118V76.1376C34.2457 76.445 34.1838 76.7491 34.0663 77.0331C33.8858 77.4688 33.5809 77.8416 33.1895 78.105C32.7981 78.3685 32.3378 78.5108 31.8659 78.5142H15.5308C15.1186 78.0958 14.7232 77.6627 14.3446 77.215C13.9792 76.7966 13.6315 76.3631 13.3023 75.9157C9.9849 71.502 8.19259 66.1307 8.19533 60.6107V60.039C8.18885 55.0604 9.64762 50.1898 12.3902 46.0332H31.8639C32.4943 46.0374 33.0978 46.2892 33.544 46.7343C33.9901 47.1793 34.2431 47.7819 34.2484 48.4118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.2,
    d: "M34.2484 48.4118V73.5391C34.2426 74.1688 33.9893 74.7708 33.5433 75.2154C33.0971 75.66 32.494 75.9116 31.8639 75.9157H13.3023C9.9849 71.502 8.19259 66.1307 8.19533 60.6107V60.0391C8.18885 55.0604 9.64762 50.1898 12.3902 46.0332H31.8639C32.4943 46.0374 33.0978 46.2892 33.544 46.7343C33.9901 47.1793 34.2431 47.7819 34.2484 48.4118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.2,
    d: "M32.9461 48.4118V73.5391C32.9403 74.1688 32.6871 74.7708 32.241 75.2154C31.7949 75.66 31.1917 75.9116 30.5617 75.9157H13.3023C9.9849 71.502 8.19259 66.1307 8.19533 60.6107V60.0391C8.18885 55.0604 9.64762 50.1898 12.3902 46.0332H30.5617C31.1921 46.0374 31.7955 46.2892 32.2417 46.7343C32.6878 47.1793 32.9408 47.7819 32.9461 48.4118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.67752 46.0332H30.5581C31.1907 46.0327 31.7977 46.2832 32.2455 46.7295C32.6933 47.1759 32.9455 47.7818 32.9466 48.4139V72.236C32.9455 72.8681 32.6933 73.4738 32.2455 73.9202C31.7977 74.3666 31.1907 74.6171 30.5581 74.6166H6.67752C6.36408 74.6176 6.0535 74.5568 5.76364 74.4376C5.47377 74.3184 5.21031 74.1432 4.9884 73.922C4.76647 73.7008 4.59046 73.438 4.47044 73.1486C4.35044 72.8593 4.28879 72.5491 4.28906 72.236V48.4139C4.28879 48.1006 4.35044 47.7904 4.47044 47.5011C4.59046 47.2118 4.76647 46.949 4.9884 46.7279C5.21031 46.5066 5.47377 46.3314 5.76364 46.2122C6.0535 46.093 6.36408 46.0322 6.67752 46.0332Z",
    fill: "url(#paint0_linear_2557_26793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M18.8795 52.3853C20.4338 52.2831 21.9742 52.7335 23.2283 53.6566C23.7435 54.1149 24.1475 54.6845 24.4095 55.3222C24.6716 55.9597 24.7848 56.6486 24.7406 57.3365C24.7575 58.3054 24.4988 59.2591 23.9944 60.0869C23.4828 60.9004 22.7473 61.5492 21.8761 61.9558C20.88 62.4179 19.7913 62.6462 18.6934 62.6234H15.6668V68.2201H12.5742V52.3853H18.8795ZM15.6649 60.2048H18.3274C19.1714 60.2647 20.0084 60.0153 20.6818 59.5032C20.957 59.2409 21.1713 58.9216 21.3096 58.5676C21.4478 58.2136 21.5067 57.8336 21.482 57.4544C21.482 55.7101 20.4651 54.8373 18.4313 54.8359H15.6649V60.2048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2557_26793",
    x1: 9.27802,
    y1: 44.1624,
    x2: 27.9359,
    y2: 76.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C5401E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62F14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2557_26793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243.765,
    height: 118.308,
    fill: "white",
    transform: "translate(0.0585938 0.587891)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpointLogo);
export default __webpack_public_path__ + "static/media/powerpoint-logo.3eea265a00de367d01977d15293e8e87.svg";
export { ForwardRef as ReactComponent };